import { render, staticRenderFns } from "./IncomeDetails.vue?vue&type=template&id=176fcb76&"
import script from "./IncomeDetails.vue?vue&type=script&lang=js&"
export * from "./IncomeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports